
const updateFormVariantID = (id:string) => {
    const $hiddenVariantIDFormField = document.querySelector<HTMLInputElement>("[data-quantity-variant-id]");
    if($hiddenVariantIDFormField) {
        $hiddenVariantIDFormField.value = id;
    }
}

const selectVariantElement = (id:string) => {
    const $productVariantButtons = document.querySelectorAll<HTMLButtonElement>("[data-selected-variant-id]")
    $productVariantButtons.forEach($singleButton => {
        const variantId = $singleButton.getAttribute("data-selected-variant-id") || '';
        $singleButton.setAttribute("data-selected", "false");
        id === variantId && $singleButton.setAttribute("data-selected", "true");
    });
}

const handleVariantSelection = (event:Event) => {
    const $currentTarget = event.currentTarget as HTMLButtonElement;
    const variantId = $currentTarget.getAttribute("data-selected-variant-id") || '';
    updateFormVariantID(variantId);
    selectVariantElement(variantId);
}

const $productVariantButtons = document.querySelectorAll<HTMLButtonElement>("[data-selected-variant-id]")
$productVariantButtons.forEach($singleButton => {
    $singleButton.addEventListener("click", handleVariantSelection);
    
});

const updateQuantityInInput = (step:number) => {
    const $input = document.querySelector<HTMLInputElement>("[data-quantity-input]");
    if($input) {
        const currentQuantity = parseInt($input.value, 10)
        const nextQuantity = currentQuantity + step;
        if(nextQuantity >= 1) {
            $input.value = String(nextQuantity);
        }
    }
    
}

const handleQuantity = (event:Event) => {
    const $currentTarget = event.currentTarget as HTMLButtonElement;
    const quantity = parseInt($currentTarget.getAttribute("data-change-quantity") || '', 10);
    updateQuantityInInput(quantity);
}

const $productAddToCartQuantityAdjusters = document.querySelectorAll<HTMLButtonElement>("[data-change-quantity]")
$productAddToCartQuantityAdjusters.forEach($singleButton => {
    $singleButton.addEventListener("click", handleQuantity)
});